// Lib dependencies
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';

if (import.meta.env.NODE_ENV !== 'production') {
  loadDevMessages();
  loadErrorMessages();
}
